import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { MenuProvider } from './contexts/MenuContext';
import { OpeningHoursProvider } from './contexts/OpeningHoursContext';
import Navbar from './components/Navbar';
import { HelmetProvider } from 'react-helmet-async';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import MenuPage from './pages/MenuPage';
import AboutPage from './pages/AboutPage';
import OrderPage from './pages/OrderPage';
import OrderSuccess from './pages/OrderSuccess';
import AdminDashboard from './pages/AdminDashboard';
import OrderPanel from './pages/OrderPanel';
import ResetPassword from './pages/ResetPassword';
import NotFoundPage from './pages/NotFoundPage';
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import TermsOfUse from './pages/TermsOfUse';
import TermsOfSale from './pages/TermsOfSale';
import DeliveryAndRefunds from './pages/DeliveryAndRefunds';
import Accessibility from './pages/Accessibility';
import Allergens from './pages/Allergens';
import CookieSettings from './pages/CookieSettings';
import CookieConsent from './components/CookieConsent';
import InstallButton from './components/InstallButton';
import './App.css';

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <MenuProvider>
        <OpeningHoursProvider>
          <Router>
          <ScrollToTop />
          <div className="App">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/menu" element={<MenuPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/order" element={<OrderPage />} />
                <Route path="/order-success" element={<OrderSuccess />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                {/* Legal */}
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/cookie-settings" element={<CookieSettings />} />
                <Route path="/terms" element={<TermsOfUse />} />
                <Route path="/terms-of-sale" element={<TermsOfSale />} />
                <Route path="/delivery-and-refunds" element={<DeliveryAndRefunds />} />
                <Route path="/accessibility" element={<Accessibility />} />
                <Route path="/allergens" element={<Allergens />} />
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedRoute requireAdmin>
                      <AdminDashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/orders" 
                  element={
                    <ProtectedRoute requireAdmin>
                      <OrderPanel />
                    </ProtectedRoute>
                  } 
                />
                {/* 404 - Catch all undefined routes */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Footer />
            <CookieConsent />
            <InstallButton />
            <Toaster 
              position="top-center"
              gutter={0}
              containerStyle={{ top: 80 }}
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#1a1a1a',
                  color: '#fff',
                  border: '1px solid #dc2626',
                  padding: '6px 10px',
                  margin: 0
                }
              }}
            />
          </div>
          </Router>
        </OpeningHoursProvider>
      </MenuProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;

